import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projects-details-services',
  templateUrl: './projects-details-services.component.html',
  styleUrls: ['./projects-details-services.component.scss']
})
export class ProjectsDetailsServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
